import React from "react";
import { InputTextarea } from "primereact/inputtextarea";

export default function TextArea(props) {
  const {
    parentClass,
    classes,
    label,
    labelOn,
    name,
    onChange,
    value,
    error,
    rows,
    explanation,
    ...other
  } = props;

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <div className="mb-2">
          <label
            htmlFor={name}
            className="block text-sm font-medium text-gray-900"
          >
            {label}
          </label>
        </div>
      ) : null}
      <div className="mt-1">
        <InputTextarea
          name={name}
          value={value}
          onChange={onChange}
          rows={rows}
          className="w-full"
          {...other}
        />
        {error ? <p className="font-medium text-red-500 mt-1">{error}</p> : null}
      </div>
    </div>
  );
}
